import type { TOC } from '@ember/component/template-only';
import { PrismToggle, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface ParityMemberRateToggleSignature {
  Args: {
    isChecked: boolean;
    onChange: () => void;
  };
  Element: HTMLSpanElement;
}

const ParityMemberRateToggle = <template>
  <span
    class="whitespace-nowrap"
    data-test-id="member-rate-toggle"
    ...attributes
  >
    <PrismToggle
      @dataTestId="member-rate-toggle-checkbox"
      @isChecked={{@isChecked}}
      @label={{t "parity_strategy.membership.member"}}
      @labelPosition="before"
      @onChange={{@onChange}}
    />
    <PrismTooltip @side="bottom" @text={{t "parity.member_rate_toggle.info"}} />
  </span>
</template> satisfies TOC<ParityMemberRateToggleSignature>;

export default ParityMemberRateToggle;
